var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9119 1.77254C10.4629 0.390576 8.50777 0.390577 8.05874 1.77254L6.75215 5.79383C6.68521 5.99984 6.49323 6.13932 6.27662 6.13932H2.04839C0.595301 6.13932 -0.00886142 7.99874 1.16671 8.85285L4.58742 11.3381C4.76266 11.4655 4.83599 11.6911 4.76905 11.8972L3.46246 15.9184C3.01343 17.3004 4.59515 18.4496 5.77072 17.5955L9.19143 15.1102C9.36668 14.9829 9.60397 14.9829 9.77922 15.1102L13.1999 17.5955C14.3755 18.4496 15.9572 17.3004 15.5082 15.9184L14.2016 11.8972C14.1347 11.6911 14.208 11.4655 14.3832 11.3381L17.8039 8.85285C18.9795 7.99874 18.3753 6.13932 16.9223 6.13932H12.694C12.4774 6.13932 12.2854 5.99984 12.2185 5.79383L10.9119 1.77254Z",
    fill: "#C1E2FF",
    stroke: "#34506F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.115948e3977f27e661b44a15d95eeb8d.svg";
export { ForwardRef as ReactComponent };